// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mandibuzz: PokeData = {
  "id": 630,
  "name": "mandibuzz",
  "height": 12,
  "weight": 395,
  "base_experience": 179,
  "types": [
    PokeType.DARK,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "fury-attack",
    "leer",
    "toxic",
    "mirror-move",
    "sky-attack",
    "feint-attack",
    "bone-rush",
    "attract",
    "flatter",
    "knock-off",
    "iron-defense",
    "pluck",
    "tailwind",
    "embargo",
    "punishment",
    "dark-pulse",
    "air-slash",
    "brave-bird",
    "nasty-plot",
    "defog"
  ],
  "moves": [
    "gust",
    "leer",
    "sky-attack",
    "flatter",
    "tailwind",
    "dark-pulse",
    "air-slash",
    "brave-bird",
    "snarl",
    "aerial-ace",
    "acrobatics",
    "quash",
    "hurricane"
  ],
  "evolution_chain": {
    "id": 320,
    "item": null,
    "species": [
      {
        "name": "vullaby",
        "order": 630,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mandibuzz",
        "order": 631,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 629,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 54,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 168,
    "speed": 128,
    "ability_power": 104
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
